import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "value", "disabled"]

import { watch, onMounted, ref, onBeforeMount, computed, toRef } from "vue";
import { useCurrencyInput, CurrencyInputOptions } from "vue-currency-input";
import { useField, ErrorMessage } from "vee-validate";
import { Schema, object } from "yup";

interface Props {
  name: string;
  options?: CurrencyInputOptions;
  initialValue?: string | number | null;
  modelValue?: string | number | null | object | unknown;
  mode?: "add" | "edit" | "view";
  rules?: Schema;
  disabled: boolean;
}

interface Emits {
  (eventName: "change", value: unknown | number | null | string): void;
  (
    eventName: "update:modelValue",
    value: unknown | number | null | string
  ): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CurrencyInput',
  props: {
    name: {},
    options: {},
    initialValue: {},
    modelValue: {},
    mode: {},
    rules: {},
    disabled: { type: Boolean }
  },
  emits: ["change", "update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const name = toRef(props, "name");
const modelValue = toRef(props, "modelValue");

const defaultOptions = ref({
  currency: "USD",
  locale: "en-US",
  precision: 2,
});

const emit = __emit;

const { formattedValue, numberValue, inputRef, setValue } = useCurrencyInput(
  props.options || defaultOptions.value
);

const { handleChange, value, errors, validate, resetField } = useField(
  name.value || "",
  props.rules || object({})
);

watch(numberValue, (newValue, oldValue) => {
  // sync it with vee-validate, this will trigger validation
  handleChange(newValue);
});

watch(modelValue, (newValue, oldValue) => {
  if (newValue === "" || newValue === null || newValue === undefined) {
    setValue(null);
  } else {
    setValue(Number(value.value));
  }
});

__expose({
  handleChange,
  value,
  formattedValue,
  inputRef,
  setValue,
  validate,
  name,
  resetField,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", _mergeProps(_ctx.$attrs, {
      class: "currency",
      name: name.value,
      ref_key: "inputRef",
      ref: inputRef,
      type: "text",
      value: _unref(formattedValue),
      disabled: __props.disabled
    }), null, 16, _hoisted_1),
    _renderSlot(_ctx.$slots, "errors")
  ], 64))
}
}

})